import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleHalfStroke, faMoon } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../context/ThemeContext';

const ThemeSwitcher = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <button
      onClick={toggleDarkMode}
      className={`px-2 py-1 rounded-full ${
        darkMode ? 'bg-yellow-400' : 'bg-blue-800'
      } ${
        darkMode ? 'text-blue-900' : 'text-white'
      } transition-colors duration-200`}
    >
      <FontAwesomeIcon icon={darkMode ? faCircleHalfStroke : faMoon} />
    </button>
  );
};

export default ThemeSwitcher;
